export default "__VITE_ASSET__Ccp0ww75__"